import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

const lightbox = new PhotoSwipeLightbox({
  gallery: '.photoswipe',
  children: '.photoswipe-item',
  showHideAnimationType: 'zoom',
  showAnimationDuration: '500',
  hideAnimationDuration: '500',

  pswpModule: () => PhotoSwipe,

  closeTitle: 'Schließen',
  zoomTitle: 'Zoomen',
  arrowPrevTitle: 'Vorheriges',
  arrowNextTitle: 'Nächstes',

  errorMsg: 'Das Bild konnte nicht geladen werden',
  indexIndicatorSep: ' von ',
});

lightbox.init();
